import { Popover, Box, Typography } from "@mui/material";
import "./alerts_modal.scss";

const ALERT_THRESHOLDS = {
  FHR: { low: 110, high: 160 },
  FHR1: { low: 110, high: 160 },
  FHR2: { low: 110, high: 160 },
  MHR: { low: 60, high: 100 },
};

const getAlertText = (alert) => {
  const { param_type, value } = alert;
const type = param_type;


  if (!type || value == null) return "Alert";

  const limits = ALERT_THRESHOLDS[type];
  if (!limits) return `${type} - ${value}`;

  if (value < limits.low) {
    return `Low ${type} - ${value}`;
  }

  if (value > limits.high) {
    return `High ${type} - ${value}`;
  }

  return `${type} - ${value}`;
};

const formatAlertClockTime = (timestamp) => {
  if (!timestamp) return "--";

  return new Date(timestamp).toLocaleTimeString("en-US", {
    hour: "numeric",
    minute: "2-digit",
    hour12: true,
  });
};

const formatAlertTime = (timestamp) => {
  if (!timestamp) return "--";

  const date = new Date(timestamp);

  const time = date.toLocaleTimeString("en-US", {
    hour: "numeric",
    minute: "2-digit",
    hour12: true,
  });

  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = date.getFullYear();

  return ` ${day}/${month}/${year}`;
};

 const hasValidMRN = (mrn) =>
  typeof mrn === "string" &&
  mrn.trim() !== "" &&
  mrn !== "NA" &&
  mrn !== "--" &&
  mrn !== "-";


const AlertsModal = ({ anchorEl, open, onClose, alerts = [], theme}) => {


  return (
    <Popover
      open={open}
      anchorEl={anchorEl}
      onClose={onClose}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "right",
      }}
      transformOrigin={{
        vertical: "top",
        horizontal: "right",
      }}
      PaperProps={{
        className: `alerts-modal ${theme}`,
        sx: {
          maxHeight: "70vh",
          overflowY: "auto",
        },
      }}
    >
      <Box>
        <Typography variant="h6" className="alerts-title">
          Active Alerts
        </Typography>

        <Typography className="alerts-sub">
          *Alerts will be displayed only during active patient monitoring.
        </Typography>

        <div className="alerts-list">
          {alerts.length === 0 ? (
            <p className="no-alerts">No active alerts</p>
          ) : (
            alerts.map((patient) => (
             
              <div key={patient.patientID} className="alert-card">
                <div className="alert-body">
                  <div className="name-time">
                    <p className="name">{patient.name}</p>
                    <div className="calender">
                      <img
            src="/dark_calender.png"
            alt="calender icon"
            className="alerts-calender"
          />
                    {Array.isArray(patient.alerts) &&
                      patient.alerts.length > 0 && (
                        <p className="meta-timestamp">
                          {formatAlertTime(
                            Math.max(...patient.alerts.map((a) => a.timestamp)),
                          )}
                        </p>
                      )}
                      </div>
                  </div>

                  <div className="sub-section">
                    <p className="meta-id">{hasValidMRN(patient.mrn)
    ? `MRN - ${patient.mrn}`
    : `ID - ${patient.patientID}`}</p>
                  </div>
                </div>

               {Array.isArray(patient.alerts) &&
  [...patient.alerts]
    .sort((a, b) => b.timestamp - a.timestamp)
    .map((a) => (
      <div
        key={`${a.param_type}-${a.timestamp}`}
        className="alert-badge"
      >
        <div className="alert-left">
          <img
            src="/alert_error_tri.png"
            alt="alerts icon"
            className="alerts-erroricon"
          />
          <span className="alert_text">{getAlertText(a)}</span>
        </div>

        <div className="alert-time">
           <img
            src="/Timer.png"
            alt="Timer icon"
            className="alerts-timer"
          />
          {formatAlertClockTime(a.timestamp)}
        </div>
      </div>
    ))}

              </div>
            ))
          )}
        </div>
      </Box>
    </Popover>
  );
};

export default AlertsModal;
